import VueRouter, { RouteConfig } from 'vue-router'

const ISCLanding = () => import('../views/LandingISC2023.vue')
const BroadcasteLanding = () => import('../views/LandingBroadcast2023.vue')

export const iscLandingRoute: RouteConfig = {
  path: '/isc_2023_landing',
  name: 'isc-2023-landing',
  component: ISCLanding,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
}

export const broadcastLandingRoute: RouteConfig = {
  path: '/broadcast_2023_landing',
  name: 'broadcast-2023-landing',
  component: BroadcasteLanding,
  props: (route) => ({ ...route.query, ...route.params, qd: route.query.qd }),
}

export default [iscLandingRoute, broadcastLandingRoute]
